import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useVerifyCheckoutSessionMutation } from '../../graphql'
import LoadingScreen from '../../common/LoadingScreen'

const VerifyPurchase = () => {
  const [searchParams] = useSearchParams()

  const contentId = searchParams.get('contentId')
  const checkoutSessionId = searchParams.get('checkoutSessionId')

  const navigate = useNavigate()

  const [verifyCheckoutSessionMutation] = useVerifyCheckoutSessionMutation({
    onCompleted: () => {
      navigate(`/content/${contentId}`)
    },
    onError: (error) => {
      // todo: handle failed purchase
      console.log(error)
    },
  })

  useEffect(() => {
    if (contentId && checkoutSessionId) {
      verifyCheckoutSessionMutation({
        variables: {
          data: {
            contentId,
            checkoutSessionId,
          },
        },
      })
    }
  }, [contentId, checkoutSessionId])

  return <LoadingScreen />
}

export default VerifyPurchase
